// API de conflitos e deletion log — extraído de App.jsx — Fase C
import { DB } from "./deviceStorage";
import { apiCall, pullGlobal, pushGlobal } from "../sync/collectionApi";
import { createClientId } from "./formatters";
import { USER_DELETION_LOG_KEY } from "./conflictUtils";

function getTimeoutSignal(ms) {
  try {
    if (typeof AbortController === "undefined") return undefined;
    const controller = new AbortController();
    const timer = setTimeout(() => {
      try { controller.abort(new DOMException("timeout", "AbortError")); } catch (e) { try { controller.abort(); } catch(_) {} }
    }, ms);
    return {
      signal: controller.signal,
      clear: () => clearTimeout(timer),
    };
  } catch (e) {
    return undefined;
  }
}

async function getUserDeletionLog(userName) {
  try {
    const local = await DB.get(USER_DELETION_LOG_KEY);
    const localArr = Array.isArray(local) ? local : [];
    try {
      const srv = await pullGlobal(USER_DELETION_LOG_KEY, userName);
      if (Array.isArray(srv?.data)) {
        const merged = [...srv.data, ...localArr]
          .filter(Boolean)
          .reduce((acc, item) => {
            const key = String(item?.id || "").trim() || JSON.stringify(item);
            if (!acc.map.has(key)) acc.map.set(key, item);
            else acc.map.set(key, { ...acc.map.get(key), ...item });
            return acc;
          }, { map:new Map() }).map;
        const out = [...merged.values()].sort((a,b)=>String(b?.deletedAt||"").localeCompare(String(a?.deletedAt||"")));
        await DB.set(USER_DELETION_LOG_KEY, out);
        return out;
      }
    } catch(_) {}
    return localArr.sort((a,b)=>String(b?.deletedAt||"").localeCompare(String(a?.deletedAt||"")));
  } catch(_) {
    return [];
  }
}

async function appendUserDeletionLog(entry, userName) {
  const record = {
    id: String(entry?.id || createClientId("udel")),
    deletedAt: entry?.deletedAt || new Date().toISOString(),
    deletedBy: entry?.deletedBy || userName || "sistema",
    ...entry,
  };
  const current = await getUserDeletionLog(userName);
  const next = [record, ...current.filter(item => String(item?.id||"") !== String(record.id||""))]
    .sort((a,b)=>String(b?.deletedAt||"").localeCompare(String(a?.deletedAt||"")));
  await DB.set(USER_DELETION_LOG_KEY, next);
  try {
    const res = await pushGlobal(USER_DELETION_LOG_KEY, next, userName);
    if (res?.version) await DB.set(`${USER_DELETION_LOG_KEY}:_ver`, res.version);
  } catch(_) {}
  try {
    window.dispatchEvent(new CustomEvent("fz:sync:updated", { detail:{ key: USER_DELETION_LOG_KEY } }));
  } catch(_) {}
  return next;
}

// Get pending conflicts for a farm
async function getConflicts(farmId, userName) {
  return await apiCall({ action:"get_conflicts", farm_id:farmId }, userName);
}

// Resolve a conflict
async function resolveConflict(conflictId, keep, userName) {
  return await apiCall({ action:"resolve_conflict", conflict_id:conflictId, keep }, userName);
}

async function getConflictResolutions(limit, userName) {
  return await apiCall({ action:"get_conflict_resolutions", limit: limit || 100 }, userName);
}

async function undoConflictResolution(resolutionId, userName) {
  return await apiCall({ action:"undo_conflict_resolution", resolution_id: resolutionId }, userName);
}



// ─── Sync status bar (bottom-right corner) ───────────────────────────────────

// ═══════════════════════════════════════════════════════════════════════════════
// THEME
// ═══════════════════════════════════════════════════════════════════════════════

export {
  getTimeoutSignal,
  getUserDeletionLog,
  appendUserDeletionLog,
  getConflicts,
  resolveConflict,
  getConflictResolutions,
  undoConflictResolution,
};
